import { render, staticRenderFns } from "./StaffProfileQualityOverview.vue?vue&type=template&id=39a916fb&scoped=true"
import script from "./StaffProfileQualityOverview.vue?vue&type=script&lang=js"
export * from "./StaffProfileQualityOverview.vue?vue&type=script&lang=js"
import style0 from "./StaffProfileQualityOverview.vue?vue&type=style&index=0&id=39a916fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a916fb",
  null
  
)

export default component.exports